import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { Settings } from "../../../styles/theme"

const Quotestyle = styled.div`
  position: relative;
  margin: 7rem 0;
  &:after,
  &:before {
    font-size: 64px;
    font-family: "Work Sans";
    font-weight: 700;
    color: ${Settings.secondaryColor};
    position: absolute;
  }
  &:after {
    content: "“";
    top: -50px;
  }
  &:before {
    content: "”";
    bottom: -70px;
    right: 0px;
  }
  p {
    text-align: center;
    color: ${Settings.primaryColor};
    font-size: 1.2rem;
  }
  .orange {
    font-size: 1rem;
    color: ${Settings.primaryColor};
  }
  .personTitle {
    font-size: 1rem;
  }
`

export const Quote = ({ children }) => <Quotestyle>{children}</Quotestyle>
